import React from 'react';
import { Project } from '../../types/project';
import { ProjectTable } from './ProjectTable';

interface FavoritesTabProps {
  projects: Project[];
}

export function FavoritesTab({ projects }: FavoritesTabProps) {
  return (
    <>
      <h2><i className="fas fa-star" aria-hidden="true" /> Favorite Projects</h2>
      <ProjectTable projects={projects} hideRoles />
    </>
  );
}
